import $ from 'jquery';
import 'select2';

class LeaderRegistration {
  attach() {
    const self = this;

    $("#church_id").select2({
      ajax: {
        delay: 250,
        dataType: 'json',
        url: 'registrations/churches'
      },
      minimumInputLength: 3,
      width: '100%'
    });

    $("#church_country").select2({
      width: '100%'
    });

    $("#church_id").on('select2:select', e => {
      if (0 == e.params.data.id) {
        $(".church-not-found-info input").prop("required", true);
        $('.url').prop('required', false);
        $('.address-two').prop('required', false);
        $('.zip-code').prop('required', false);
        $('.arc').prop('required', false);
        $('.international-state').prop('required', false);
        $(".church-not-found-info").show();
      }
      else {
        $(".church-not-found-info input").prop("required", false);
        $(".church-not-found-info select").prop("required", false);
        $(".church-not-found-info").hide();
      }
    });
  }
}

$(() => {
  const registration = new LeaderRegistration();
  registration.attach();
});
